// TypeScript wrapper for cashout_pb to handle CommonJS in browser environment
// This file provides ES6 module exports for the generated protobuf classes

// Import google-protobuf as ES6 module
import * as jspb from 'google-protobuf';

// Define the protobuf message classes
export class CashoutStatusRequest extends jspb.Message {
  private taskid = '';

  getTaskid(): string {
    return this.taskid;
  }

  setTaskid(value: string): CashoutStatusRequest {
    this.taskid = value;
    return this;
  }

  serializeBinary(): Uint8Array {
    const writer = new jspb.BinaryWriter();
    CashoutStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  toObject(includeInstance?: boolean): CashoutStatusRequest.AsObject {
    return {
      taskid: this.getTaskid(),
    };
  }

  static override toObject(
    includeInstance: boolean,
    msg: CashoutStatusRequest,
  ): CashoutStatusRequest.AsObject {
    return {
      taskid: msg.getTaskid(),
    };
  }

  static override deserializeBinary(bytes: Uint8Array): CashoutStatusRequest {
    const reader = new jspb.BinaryReader(bytes);
    const msg = new CashoutStatusRequest();
    return CashoutStatusRequest.deserializeBinaryFromReader(msg, reader);
  }

  static override deserializeBinaryFromReader(
    msg: CashoutStatusRequest,
    reader: jspb.BinaryReader,
  ): CashoutStatusRequest {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      const field = reader.getFieldNumber();
      switch (field) {
        case 1:
          msg.setTaskid(reader.readString());
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  }

  static override serializeBinaryToWriter(
    message: CashoutStatusRequest,
    writer: jspb.BinaryWriter,
  ): void {
    const taskid = message.getTaskid();
    if (taskid.length > 0) {
      writer.writeString(1, taskid);
    }
  }
}

export namespace CashoutStatusRequest {
  export type AsObject = {
    taskid: string;
  };
}

export class CashoutStatusResponse extends jspb.Message {
  private taskid = '';
  private status = '';
  private reasonforrejection = '';
  private transactionhash = '';

  getTaskid(): string {
    return this.taskid;
  }

  setTaskid(value: string): CashoutStatusResponse {
    this.taskid = value;
    return this;
  }

  getStatus(): string {
    return this.status;
  }

  setStatus(value: string): CashoutStatusResponse {
    this.status = value;
    return this;
  }

  getReasonforrejection(): string {
    return this.reasonforrejection;
  }

  setReasonforrejection(value: string): CashoutStatusResponse {
    this.reasonforrejection = value;
    return this;
  }

  getTransactionhash(): string {
    return this.transactionhash;
  }

  setTransactionhash(value: string): CashoutStatusResponse {
    this.transactionhash = value;
    return this;
  }

  serializeBinary(): Uint8Array {
    const writer = new jspb.BinaryWriter();
    CashoutStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  toObject(includeInstance?: boolean): CashoutStatusResponse.AsObject {
    return {
      taskid: this.getTaskid(),
      status: this.getStatus(),
      reasonforrejection: this.getReasonforrejection(),
      transactionhash: this.getTransactionhash(),
    };
  }

  static override toObject(
    includeInstance: boolean,
    msg: CashoutStatusResponse,
  ): CashoutStatusResponse.AsObject {
    return {
      taskid: msg.getTaskid(),
      status: msg.getStatus(),
      reasonforrejection: msg.getReasonforrejection(),
      transactionhash: msg.getTransactionhash(),
    };
  }

  static override deserializeBinary(bytes: Uint8Array): CashoutStatusResponse {
    const reader = new jspb.BinaryReader(bytes);
    const msg = new CashoutStatusResponse();
    return CashoutStatusResponse.deserializeBinaryFromReader(msg, reader);
  }

  static override deserializeBinaryFromReader(
    msg: CashoutStatusResponse,
    reader: jspb.BinaryReader,
  ): CashoutStatusResponse {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      const field = reader.getFieldNumber();
      switch (field) {
        case 1:
          msg.setTaskid(reader.readString());
          break;
        case 2:
          msg.setStatus(reader.readString());
          break;
        case 3:
          msg.setReasonforrejection(reader.readString());
          break;
        case 4:
          msg.setTransactionhash(reader.readString());
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  }

  static override serializeBinaryToWriter(
    message: CashoutStatusResponse,
    writer: jspb.BinaryWriter,
  ): void {
    const taskid = message.getTaskid();
    if (taskid.length > 0) {
      writer.writeString(1, taskid);
    }
    const status = message.getStatus();
    if (status.length > 0) {
      writer.writeString(2, status);
    }
    const reasonforrejection = message.getReasonforrejection();
    if (reasonforrejection.length > 0) {
      writer.writeString(3, reasonforrejection);
    }
    const transactionhash = message.getTransactionhash();
    if (transactionhash.length > 0) {
      writer.writeString(4, transactionhash);
    }
  }
}

export namespace CashoutStatusResponse {
  export type AsObject = {
    taskid: string;
    status: string;
    reasonforrejection: string;
    transactionhash: string;
  };
}
